/* THIS FILE IS GENERATED. DO NOT EDIT */

import { PropsFromComponent } from '@/types/component';
import { withDebugMetadata } from '@/utils/withDebugMetadata';
import { withLabradorInstanceof } from '@/utils/withInstanceofProp';
import { LabradorJwVideoShoppable as ResolvedLabradorJwVideoShoppable } from 'base/components/labrador/JwVideo/Shoppable';

export const LabradorJwVideoShoppable: typeof ResolvedLabradorJwVideoShoppable = withLabradorInstanceof((props) => {
    return <ResolvedLabradorJwVideoShoppable {...props} {...withDebugMetadata({type: props.type, meta: props.meta})} />;
});

export type LabradorJwVideoShoppableProps = PropsFromComponent<typeof LabradorJwVideoShoppable>;
